export default {"src":"/_next/static/media/emojiHug.f15e78fa.svg","height":97,"width":96};